<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[1167]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="years" :label="$t('getapi[4987]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vendercode" :label="$t('getapi[1338]')"></el-table-column>
            <el-table-column prop="one_month" :label="$t('getapi[1986]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.one_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="two_month" :label="$t('getapi[1987]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.two_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="three_month" :label="$t('getapi[1988]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.three_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="four_month" :label="$t('getapi[1989]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.four_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="five_month" :label="$t('getapi[1990]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.five_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="six_month" :label="$t('getapi[1991]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.six_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="seven_month" :label="$t('getapi[1992]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.seven_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="eight_month" :label="$t('getapi[1993]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.eight_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="nine_month" :label="$t('getapi[1994]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.nine_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="ten_month" :label="$t('getapi[1995]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.ten_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="eleven_month" :label="$t('getapi[1996]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.eleven_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="twelve_month" :label="$t('getapi[1997]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.twelve_month | thousandthpuramount}}
                </template>
            </el-table-column>
            <el-table-column prop="month_totals" label="统计" align="right">
                <template slot-scope="scope">
                    {{scope.row.month_totals | thousandthpuramount}}
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurStatBuyerInfoData" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'purstatbuyer',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize:this.$http.getPageSize('purstatbuyer'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8011]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv2', 528, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                if (that.$limits.authority('plv2', 528, 1) == 2) {
                    if (that.$limits.authority('plv3', 528, 1) == 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 528, 1) == 1) {
                        //编辑级
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    if (that.$limits.authority('plv3', 528, 1) == 2) {
                        //删除级
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purstatbuyer',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurStatBuyerInfoData');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Statistics/GetPurStatBuyerList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[8011]')
                };
                that.$http.urlpost('/Pur/Statistics/GetPurStatBuyerToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
